import React from 'react';
import ReactTooltip from 'react-tooltip';
import './index.less';

export class FaithlifeFamilySites extends React.Component {
	render() {
		return (
			<div className="faithlife-family-sites">
				Your Faithlife account signs you in to all our sites and apps.
				<br />
				<img src="/public/images/faithlife-sign-in-icon.svg" alt="Faithlife" data-tip="Faithlife" data-border />
				<ReactTooltip />
				<img
					src="/public/images/faithlife-tv-sign-in-icon.svg"
					alt="Faithlife TV"
					data-tip="Faithlife TV"
					data-border
				/>
				<ReactTooltip />
				<img
					src="/public/images/faithlife-courses-sign-in-icon.svg"
					alt="Faithlife Courses"
					data-tip="Faithlife Courses"
					data-border
				/>
				<ReactTooltip />
				<img
					src="/public/images/faithlife-sermons-sign-in-icon.svg"
					alt="Faithlife Sermons"
					data-tip="Faithlife Sermons"
					data-border
				/>
				<ReactTooltip />
			</div>
		);
	}
}
